module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fcLSd"))).then(() => parcelRequire('d0iPb'));